import {
  type CreatCustomerDTO,
  type OrderAddressDTO,
  type QliroOrder,
  type WithOptional
} from 'ecosystem'

export const generateQliroAddresses = (
  qliroOrder: QliroOrder
): {
  billingAddress: OrderAddressDTO
  shippingAddress: OrderAddressDTO
  customerInfo: WithOptional<CreatCustomerDTO, 'type'> & { fullName: string; phone: string }
} => {
  const {
    BillingAddress: billingAddress,
    ShippingAddress: shippingAddress,
    Customer: customer
  } = qliroOrder

  const firstName = billingAddress?.FirstName ?? ''
  const lastName = billingAddress?.LastName ?? ''
  const fullName = `${firstName} ${lastName}`.trim()
  const email = customer?.Email ?? ''
  const phone = customer?.MobileNumber ?? ''

  return {
    billingAddress: {
      address1: billingAddress?.Street ?? '',
      address2: billingAddress?.Street2 ?? '',
      country: billingAddress?.CountryCode ?? '',
      mobilePhone: phone,
      postalCode: String(billingAddress?.PostalCode ?? ''),
      postalRegion: billingAddress?.City ?? '',
      attention: fullName,
      reference: ''
    },
    shippingAddress: {
      address1: shippingAddress?.Street ?? '',
      address2: shippingAddress?.Street2 ?? '',
      country: shippingAddress?.CountryCode ?? '',
      mobilePhone: phone,
      postalCode: String(shippingAddress?.PostalCode ?? ''),
      postalRegion: shippingAddress?.City ?? '',
      attention: `${shippingAddress?.FirstName ?? ''} ${shippingAddress?.LastName ?? ''}`.trim(),
      reference: ''
    },
    customerInfo: {
      email,
      firstName,
      lastName,
      phone,
      fullName
    }
  }
}
